import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=70cc2de3&scoped=true&"
import script from "./BulkActions.vue?vue&type=script&lang=js&"
export * from "./BulkActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=70cc2de3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc2de3",
  null
  
)

export default component.exports